<template>
  <div :class="'as-incident-player as-' + type">
    <div class="as-point">{{ point }}</div>
    <div class="as-player">
      <!-- <img
        :src="getImgUrlBySport('player', player[1])"
        class="as-player-logo"
        :alt="playerName"
      /> -->
      <div class="as-player-detail">
        <div class="as-player-point">{{props.player.homeScore }} - {{props.player.awayScore }} </div>
        <!-- <div class="as-player-name">{{ playerName }}</div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { IPlayer } from "~src/interfaces/basketball";

interface IProps {
  player: IPlayer | any;
  playerName: string;
  point: number;
  type: string;
  pointHomeMatch: number[];
  pointAwayMatch: number[];
  indexCurrentScore: number;
}

const props = withDefaults(defineProps<IProps>(), {
  type: 'home'
});
const scoreData = computed(() => {
  let pointHome = 0;
  let pointAway = 0;
  for (let i = 0; i < props.indexCurrentScore; i++) {
    pointHome += props.pointHomeMatch[i];
  }
  for (let i = 0; i < props.indexCurrentScore; i++) {
    pointAway += props.pointAwayMatch[i];
  }
  return {
    homeScore: pointHome,
    awayScore: pointAway
  };
});
</script>

<script lang="ts">
export default {};
</script>
